import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import moment from 'moment';
import { Edit, Trash } from 'lucide-react';
import BtnSpinner from '../../components/BtnSpinner';
import Pagination from '../../components/Pagination';
import { Apirequests } from '../../utils/ApiRequests';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import CourseDetails from './CourseDetails';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import AddOrEditCourse from './AddOrEditCourse';

function Courses() {

  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
  const [courses, setCourses] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState({ state: false, name: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [deleteId, setdeleteId] = useState(null)

  const token = localStorage.getItem("token");


  const totalItems = courses?.length; // Total number of items
  const itemsPerPage = 20;

  const currentData = courses?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const handleRefresh = () => setRefresh(!refresh);

  const handleSearch = async () => {
    if (!searchTerm) {
        return ErrorTost("Enter a key to serach")
    }

    if(currentPage!==1){
      setCurrentPage(1)
    }
    
    await getCourses(searchTerm)
};


  const getCourses = async () => {
    setLoading({ state: true, name: "fetchcourses" });
    try {
      const res = await Apirequests(
        `courses/get-courses?q=${searchTerm}`,
        "GET",
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );
      //   console.log(res,'course get res')
      if (res?.success) {
        setCourses(res.data);
      }
    } catch (error) {
      console.log(error, "course res error.");
    }
    setLoading({ state: false, name: "" });
  };

  const deleteCourse = async (id) => {
    setdeleteId(id);
    setLoading({ state: true, name: 'deletecourse' })
    try {
      const deleteRes = await Apirequests(
        `courses/delete-course/${id}`,
        "DELETE",
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );
      // console.log(deleteRes,'delete lead');
      setRefresh(!refresh);
      if (deleteRes?.success) {
        SuccessTost(deleteRes?.message);
      } else {
        ErrorTost(deleteRes?.message);
      }
    } catch (error) {
      console.log(error, "delete course error");
      ErrorTost("Something went wrong, please try again later.")
    }
    setdeleteId(null);
    setLoading({ state: false, name: "" })
  };

  useEffect(() => {
    getCourses();
  }, [refresh, token]);

  if (loading.state && loading.name === "fetchcourses") {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }

  // console.log(currentCourse,'cur')


  return (
    <div>
      <CustomPageHeader
        title={"Courses"}
        text={searchTerm}
        setText={setSearchTerm}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: "addcourse" })}
        btnText={"Add Course"}
        handleBackClick={() => navigate("/")}
        handleRefresh={handleRefresh}
        handleDownload={() => downloadExcel(courses, 'courses')}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead className="bg-gray-50 text-center">
                <tr>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Course Id</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Course Title</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Discount</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Chapters</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Validity</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 text-center">
                {currentData?.map((course) => (
                  <tr key={course.id}>

                    <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: "viewcourse" }); setCurrentCourse(course) }}>{course?.course_id}</span></td>
                    <td className="px-6 py-4 whitespace-nowrap">{course?.course_title}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{course?.course_price}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{course?.course_discount_percentage}%</td>
                    <td className="px-6 py-4 whitespace-nowrap">{course?.course_status}</td>
                    <td className="px-6 py-4 whitespace-nowrap"><Link to={`/${course?.course_id}/chapters`}><span className='text-indigo-600 cursor-pointer'>{course?.chapters?.length}</span></Link></td>
                    <td className="px-6 py-4 whitespace-nowrap">{course?.notes?.validity || "Lifetime"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(course?.createdAt).format("DD-MM-YY")}</td>
                    <td className="px-6 py-4 flex gap-5 justify-center">
                      <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editcourse" }); setCurrentCourse(course) }}>
                        <Edit className='text-white' size={20} />
                        <span className='text-white text-sm'>Edit</span>
                      </button>
                      <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => deleteCourse(course?.course_id)}>
                        {
                          loading.state && loading.name === "deletecourse" && deleteId === course?.course_id ?
                            <BtnSpinner /> :
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                        }

                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {courses?.length ?
          <div className="flex gap-x-2 items-center justify-between">
            <p>total: {courses?.length}</p>
            <Pagination
              page={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div> : null}
      </main>

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "viewcourse"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
        content={
          <CourseDetails
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
            setRefresh={setRefresh}
            course={currentCourse}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addcourse"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
        content={
          <AddOrEditCourse
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
            setRefresh={setRefresh}
            course={currentCourse}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editcourse"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
        content={
          <AddOrEditCourse
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCourse(null) }}
            setRefresh={setRefresh}
            course={currentCourse}
          />
        }
      />

    </div>
  )
}

export default Courses